import SortOrders from "./sort-orders";
import Parameter from "./parameter";
import { sortByOrder } from "../utils";
import IExcelExport from "../interface/excel-export";
import ParamStorage from "../enum/param-storage";
import ParameterStorage from "../class/parameter-storage";

class ExcelExportTemplateSingleton {

    private readonly Store = ParamStorage.ExcelExport;

    /* Public Methods */

    public getAll(entityId: number | null = null): IExcelExport[] {
        if (entityId) {
            const order: number[] = SortOrders.get(this.Store, entityId);
            const result: IExcelExport[] = this.getStore().getAll().filter((t: IExcelExport) => t.entityId === entityId);
            return sortByOrder(result, 'id', order);
        } else {
            return this.getStore().getAll();
        }
    }

    public get(id: number): IExcelExport | null {
        return this.getStore().get(id);
    }

    public async delete(id: number): Promise<number> {
        return await this.getStore().delete(id);
    }

    public async setOrder(entityId: number | null = null, order: number[]): Promise<IExcelExport[]> {
        await SortOrders.set({ param: this.Store, entityId, order });
        return this.getAll(entityId);
    }

    /* Private Public Methods */

    public async create(tpl: IExcelExport): Promise<IExcelExport> {
        return await this.getStore().create(tpl);
    }

    public async update(tpl: IExcelExport): Promise<IExcelExport> {
        return await this.getStore().update(tpl);
    }

    public async deleteByEntityId(entityId: number): Promise<number[]> {
        const ids: number[] = this.getAll(entityId).map((t: IExcelExport) => t.id as number);
        this.getStore().bulk([], [], ids);
        return ids;
    }

    /* Private Methods - Parameter Storage */

    private getStore(): ParameterStorage<IExcelExport> {
        return Parameter.get(this.Store);
    }

}

const ExcelExportTemplate = new ExcelExportTemplateSingleton();

export default ExcelExportTemplate;